/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Rag_AnswerInputs */

const en_faq_rag_answer = /** @type {(inputs: Faq_Rag_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. We build RAG (retrieval-augmented generation) systems that search your approved documents, price lists, policies and records, then prepare an answer that shows where it came from. The same knowledge base can power a customer support chatbot on your website or an internal AI assistant for your team.`)
};

const lv_faq_rag_answer = /** @type {(inputs: Faq_Rag_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jā. Mēs veidojam RAG (retrieval-augmented generation) sistēmas, kas meklē Jūsu apstiprinātajos dokumentos, cenrāžos, noteikumos un ierakstos un sagatavo atbildi, kas parāda savu avotu. Tā pati zināšanu bāze var darbināt klientu atbalsta čatbotu Jūsu mājaslapā vai iekšējo AI asistentu komandai.`)
};

/**
* | output |
* | --- |
* | "Yes. We build RAG (retrieval-augmented generation) systems that search your approved documents, price lists, policies and records, then prepare an answer tha..." |
*
* @param {Faq_Rag_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_rag_answer = /** @type {((inputs?: Faq_Rag_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Rag_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_rag_answer(inputs)
	return en_faq_rag_answer(inputs)
});